export default __webpack_public_path__ + "static/media/WebResume4.769f2e9e.png";